import { render, staticRenderFns } from "./GenericPictureUpload.vue?vue&type=template&id=4c254878"
import script from "./GenericPictureUpload.vue?vue&type=script&lang=js"
export * from "./GenericPictureUpload.vue?vue&type=script&lang=js"
import style0 from "./GenericPictureUpload.vue?vue&type=style&index=0&id=4c254878&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports